import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { EntityLink } from "~/components/entity-link";
import type { topicSearchResultListItemTopic$key } from "~/queries/__generated__/topicSearchResultListItemTopic.graphql";

import { Container, TitleContainer, TopicTitle } from "./styles";

export type Props = {
  reference: topicSearchResultListItemTopic$key;
};

export const TopicSearchResultListItem: FunctionComponent<Props> = ({
  reference: reference_,
  ...props
}) => {
  const topic = useFragment<topicSearchResultListItemTopic$key>(
    graphql`
      fragment topicSearchResultListItemTopic on Topic {
        name
        ...entityLink
      }
    `,
    reference_,
  );

  return (
    <Container {...props}>
      <EntityLink reference={topic}>
        <TitleContainer>
          <TopicTitle>{topic.name}</TopicTitle>
        </TitleContainer>
      </EntityLink>
    </Container>
  );
};

TopicSearchResultListItem.displayName = "TopicSearchResultListItem";
